var path = '/components/event-info/event-info.template.html';
var html = "<span class=event-info> {{ eventName }}<br/> <span ng-if=eventDateWithTimezone> {{ 'components.eventInfo.eventDatetime' | i18next: { date: eventDateWithTimezone } }} </span> </span> ";
window.angular.module('citifydMonitoring').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;